<template>
  <section class="content">
    <div class="row center-block">
      <!--      <h2>Data tables</h2>-->
      <div class="col-md-12 row-rm-padding">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title pull-right">
              <button type="button" @click="newModal = true" class="btn primary-btn-my clear-new-modal">Add</button>
              <!--   <div class="logMe" data-log-id="10">Something</div>-->
              <div id="events"></div>
            </h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-6">
                  <div id="example1_length" class="dataTables_length">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table aria-describedby="example1_info" role="grid" id="tableData"
                         class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th aria-label="Rendering engine: activate to sort column descending" aria-sort="ascending"
                          style="width:10%" colspan="1" rowspan="1" aria-controls="example1" tabindex="0"
                          class="sorting_asc">Date
                      </th>
                      <th aria-label="Browser: activate to sort column ascending" style="width:20%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Name
                      </th>
                      <th aria-label="Platform(s): activate to sort column ascending" style="width:10%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Category
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width:28%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Description

                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width:10%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">RCP Products
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width:5%" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">State
                      </th>
                      <th style="width:17%" colspan="1" rowspan="1" tabindex="0">Actions</th>
                    </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <!-- ========== Add new video ======== -->
     <md-dialog :md-active.sync="newModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Add New Video
        <a style="float: right;cursor: pointer;" class="md-primary" @click="newModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding modal-width-100">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClassNewForm('name')">
                <label class="lable-fileds">Name</label>
                <md-input maxlength="100" id="name" name="name" v-model="newForm.name"/>
                <span class="md-error" v-if="!$v.newForm.name.required">The Name is required</span>
                <span class="md-error" v-if="$v.newForm.name.required && this.newFormBackendValidation.name.isError">{{this.newFormBackendValidation.name.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClassNewForm('description')">
                <label class="lable-fileds">Description</label>
                <md-input maxlength="500" name="description" id="description" v-model="newForm.description"/>
                <span class="md-error" v-if="!$v.newForm.description.required">The description is required</span>
                <span class="md-error" v-if="$v.newForm.description.required && this.newFormBackendValidation.description.isError">{{this.newFormBackendValidation.description.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClassNewForm('category_id')" class="category_id">
                <label class="lable-fileds">Category</label>
                <md-select v-model="newForm.category_id" name="category" id="category">
                  <md-option v-for="item in categoriesSelection" v-bind:key="item.id" :value="item.id">
                    {{item.name}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.newForm.category_id.required">The category is required</span>
                <span class="md-error" v-if="$v.newForm.category_id.required && this.newFormBackendValidation.category_id.isError">{{this.newFormBackendValidation.category_id.errorMsg}}</span>
              </md-field>
               <!-- <md-field :class="getValidationClassNewForm('products')" class="products">
                <label v-if="ProductSelected.length != 0" class="multiLable">Products</label>
                <multiselect v-model="ProductSelected" tag-placeholder="Add industries as new tag" placeholder="Products" label="name" track-by="id" :options="productsSelection" :multiple="true" :taggable="true"></multiselect>
                <span class="md-error" v-if="!$v.newForm.products.required">The product is required</span>
                <span class="md-error" v-if="$v.newForm.products.required && this.newFormBackendValidation.products.isError">{{this.newFormBackendValidation.products.errorMsg}}</span>
              </md-field> -->
              <md-field :class="getValidationClassNewForm('products')" class="products">
                <label class="lable-fileds">Products</label>
                <md-select name="product" id="product" multiple v-model="newForm.products">
                  <md-option v-for="item in productsSelection" v-bind:key="item.id" :value="item.id">
                    {{item.name}}
                  </md-option>
                </md-select>
                <span class="md-error" v-if="!$v.newForm.products.required">The product is required</span>
                <span class="md-error" v-if="$v.newForm.products.required && this.newFormBackendValidation.products.isError">{{this.newFormBackendValidation.products.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClassNewForm('url')" class="url">
                <label class="lable-fileds">Video Link</label>
                <md-input type="text" id="url" name="url" v-model="newForm.url"/>
                <span class="md-error" v-if="!$v.newForm.url.required">The Video Link is required</span>
              </md-field>
              <md-field :class="getValidationClassNewForm('industries')">
                <label v-if="IndustrySelected.length != 0" class="multiLable">Industries</label>
                <multiselect v-model="IndustrySelected" tag-placeholder="Add industries as new tag" placeholder="Search or add an industries" label="name" track-by="id" :options="IndustriesList" :multiple="true" :taggable="true"></multiselect>
                <span class="md-error" v-if="!$v.newForm.industries.required">The Industries is required</span>
                <span class="md-error" v-if="$v.newForm.industries.required && this.newFormBackendValidation.industries.isError">{{this.newFormBackendValidation.industries.errorMsg}}</span>
              </md-field>
              <md-field :class="getValidationClassNewForm('states')" class="device_type">
                <label v-if="newForm.states.length != 0" class="multiLable" >Select State</label>
                    <ejs-multiselect
                      id='multiselect'
                      :dataSource='StateList'
                      :fields='fields' popupHeight="300px"
                      mode="CheckBox" enableGroupCheckBox="true"
                      allowFiltering="true"
                      v-model="newForm.states"
                      filterBarPlaceholder="Search State"
                      showSelectAll="true"
                      placeholder="Select State">
                    </ejs-multiselect>
                    <span class="md-error" v-if="!$v.newForm.states.required">Select the states is required</span>
                    <span class="md-error" v-if="$v.newForm.states.required && this.newFormBackendValidation.states.isError">{{this.newFormBackendValidation.states.errorMsg}}</span>
                </md-field>
              <md-field :class="getValidationClassNewForm('device_type')" class="device_type">
                <label class="lable-fileds">Allowed Device Type</label>
                <md-select v-model="newForm.device_type" name="device_type" id="device_type" md-dense>
                  <md-option value="b">Mobile and Web</md-option>
                  <md-option value="m">Only Mobile</md-option>
                  <md-option value="w">Only Web</md-option>
                </md-select>
                <span class="md-error" v-if="!$v.newForm.device_type.required">The Allowed Device Type is required</span>
                <span class="md-error" v-if="$v.newForm.device_type.required && this.newFormBackendValidation.device_type.isError">{{this.newFormBackendValidation.device_type.errorMsg}}</span>
              </md-field>
            </div>
          </div>

          <div class="custom-modal-footer-spaces"></div>

          <div class="custom-modal-footer-container">
            <button type="button" @click="validateUser" class="btn primary-btn-my custom-modal-footer-items">Add Video</button>
            &nbsp;&nbsp;&nbsp;
            <sync-loader class="custom-modal-footer-items" :loading="newModalLoading" :color="newModalColor" :size="newModalSize" :width="newModalWidth" :margin="newModalMargin"></sync-loader>
          </div>

        </form>
    </md-dialog>
    <!-- ================== Edit Video model ================== -->
     <md-dialog :md-active.sync="editModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Edit Video
        <a style="float: right;cursor: pointer;" class="md-primary" @click="editModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding modal-width-100">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('name')" class="name">
                    <label class="lable-fileds">Name</label>
                    <md-input maxlength="100" name="name" id="name" v-model="form.name"/>
                    <span class="md-error" v-if="!$v.form.name.required">The Name is required</span>
                    <span class="md-error" v-if="$v.form.name.required && this.editFormBackendValidation.name.isError">{{this.editFormBackendValidation.name.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('description')" class="description">
                    <label class="lable-fileds">Description</label>
                    <md-input maxlength="500" name="description" id="description" v-model="form.description"/>
                    <span class="md-error" v-if="!$v.form.description.required">The description is required</span>
                    <span class="md-error" v-if="$v.form.description.required && this.editFormBackendValidation.description.isError">{{this.editFormBackendValidation.description.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('category_id')" class="category_id">
                    <label class="lable-fileds">Category</label>
                    <md-select v-model="form.category_id" name="category_id" id="category_id">
                      <md-option v-for="item in categoriesSelection" v-bind:key="item.id" :value="item.id">
                        {{item.name}}
                      </md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.category_id.required">The category is required</span>
                    <span class="md-error" v-if="$v.form.category_id.required && this.editFormBackendValidation.category_id.isError">{{this.editFormBackendValidation.category_id.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('products')" class="products">
                    <label class="lable-fileds">Products</label>
                    <md-select name="products" id="products" multiple v-model="form.products">
                      <md-option v-for="item in productsSelection" v-bind:key="item.id" :value="item.id">
                        {{item.name}}
                      </md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.products.required">The product is required</span>
                    <span class="md-error" v-if="$v.form.products.required && this.editFormBackendValidation.products.isError">{{this.editFormBackendValidation.products.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('url')" class="url">
                    <label class="lable-fileds">Video Link</label>
                    <md-input type="text" name="url" id="url" v-model="form.url"/>
                    <span class="md-error" v-if="!$v.form.url.required">The Video Link is required</span>
                    <span class="md-error" v-if="$v.form.url.required && this.editFormBackendValidation.url.isError">{{this.editFormBackendValidation.url.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('industries')">
                    <label v-if="IndustrySelected.length != 0" class="multiLable">Industries</label>
                    <multiselect v-model="IndustrySelected" tag-placeholder="Add industries as new tag" placeholder="Search or add an industries" label="name" track-by="id" :options="IndustriesList" :multiple="true" :taggable="true"></multiselect>
                    <span class="md-error" v-if="!$v.form.industries.required">The Industries is required</span>
                    <span class="md-error" v-if="$v.form.industries.required && this.editFormBackendValidation.industries.isError">{{this.editFormBackendValidation.industries.errorMsg}}</span>
                  </md-field>
                  <!-- <md-switch v-model="status" class="md-primary">Active/Deactive</md-switch>-->
                  <!-- <div class="md-layout-item">-->
                  <md-field :class="getValidationClass('states')" class="states">
                  <label  v-if="form.states.length != 0" class="multiLable" >Select State</label>
                      <ejs-multiselect
                        id='multiselect'
                        :dataSource='StateList'
                        :fields='fields' popupHeight="300px"
                        mode="CheckBox" enableGroupCheckBox="true"
                        allowFiltering="true"
                        v-model="form.states"
                        filterBarPlaceholder="Search State"
                        showSelectAll="true"
                        placeholder="Select State">
                      </ejs-multiselect>
                      <span class="md-error" v-if="!$v.form.states.required">Select the states is required</span>
                    <span class="md-error" v-if="$v.form.states.required && this.editFormBackendValidation.states.isError">{{this.editFormBackendValidation.states.errorMsg}}</span>
                    </md-field>
                  <md-field :class="getValidationClass('device_type')" class="device_type">
                    <label class="lable-fileds">Allowed Device Type</label>
                    <md-select v-model="form.device_type" name="device_type" id="device_type" md-dense>
                      <md-option value="b">Mobile and Web</md-option>
                      <md-option value="m">Only Mobile</md-option>
                      <md-option value="w">Only Web</md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.device_type.required">The Allowed Device Type is required</span>
                    <span class="md-error" v-if="$v.form.device_type.required && this.editFormBackendValidation.device_type.isError">{{this.editFormBackendValidation.device_type.errorMsg}}</span>
                  </md-field>
                  <md-field>
                    <label class="lable-fileds">Status</label>
                    <md-select v-model="form.status" name="status" id="status" md-dense>
                      <md-option v-bind:value="1">Active</md-option>
                      <md-option v-bind:value="0">Deactive</md-option>
                      <!-- <md-option v-bind:value="-1">Delete</md-option>-->
                    </md-select>
                  </md-field>
                </div>
              </div>

          <div class="custom-modal-footer-spaces"></div>

          <div class="custom-modal-footer-container">
            <button type="button" @click="validateUser" class="btn primary-btn-my custom-modal-footer-items">
              Update
            </button>
            &nbsp;&nbsp;&nbsp;
            <sync-loader class="custom-modal-footer-items" :loading="editModalLoading" :color="editModalColor" :size="editModalSize"
                         :width="editModalWidth" :margin="editModalMargin"></sync-loader>
          </div>


            </form>
    </md-dialog>

    <!-- ================== Notifi Modal Video model ================== -->
     <md-dialog :md-active.sync="notifiModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Notification Control
        <a style="float: right;cursor: pointer;" class="md-primary" @click="notifiModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding modal-width-100">
          <md-field>
            <label class="lable-fileds">Select Filter Type</label>
            <md-select name="product" id="product" v-model="filter.filter_type" @md-selected="loadFilterData(filter.filter_type)">
              <md-option value="industry">Industries</md-option>
              <md-option value="organization">Organizations</md-option>
              <md-option value="state">States</md-option>
              <md-option value="user">Users</md-option>
            </md-select>
          </md-field>
          <md-field>
            <label class="lable-fileds">Select options</label>
            <md-select name="product" id="product" v-model="selectFilter_value" multiple :disabled="isDisabledOption" @md-selected="GetUserCount(selectFilter_value)">
              <md-option value="all">All</md-option>
              <md-option v-for="item in filterType" v-bind:key="item.id" :value="item.id">
                {{item.name}}
              </md-option>
            </md-select>
          </md-field>
          <span>Users Count : {{filterUserCount}}</span>

          <div class="custom-modal-footer-spaces"></div>

          <div class="custom-modal-footer-container">
            <button type="button" @click="triggerNotification" class="btn primary-btn-my custom-modal-footer-items">
              Trigger Notification
            </button>
            &nbsp;&nbsp;&nbsp;
            <sync-loader class="custom-modal-footer-items" :loading="editModalLoading" :color="editModalColor"
                         :size="editModalSize"
                         :width="editModalWidth" :margin="editModalMargin"></sync-loader>
          </div>

        </form>
    </md-dialog>

    <!-- ================== QR Modal ================== -->
     <md-dialog :md-active.sync="qrModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">QR Control
        <a style="float: right;cursor: pointer;" class="md-primary" @click="qrModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding modal-width-100">
        <div style="text-align: center;" id="printSection">
          <div v-if="haveQR">
            <div>
                <img src="/static/img/qrcode.gif" style="    width: 87%;" alt="QR Image">
            </div>
            <div style="display:none">
            <vue-qr :bgSrc='src' :logoSrc="src2" :correctLevel='3' :logoScale='0.3' :dotScale='0.90' :callback="generateQRimageURL" qid="testid"  :text="qrRef"  :size="400"></vue-qr>
            </div>
          </div>
          <div v-else>
            <img :src="'https://smartapprcp.s3-ap-southeast-1.amazonaws.com/'+ this.qrcode.qr_url" alt="QR Image">
          </div>
           </div>

          <div class="custom-modal-footer-spaces"></div>

          <div class="custom-modal-footer-container">

            <button type="button" class="btn primary-btn-my custom-modal-footer-items" @click="printQR" v-if="!haveQR">
              Print QR
            </button>
            <button type="button" class="btn primary-btn-my custom-modal-footer-items" @click="uploadQrCode"
                    v-else>
              Generate QR
            </button>
            &nbsp;&nbsp;&nbsp;
            <sync-loader class="custom-modal-footer-items" :loading="editModalLoading" :color="editModalColor"
                         :size="editModalSize"
                         :width="editModalWidth" :margin="editModalMargin"></sync-loader>

          </div>

        </form>
    </md-dialog>

  </section>

</template>

<script>
  import AWS from 'aws-sdk'
  AWS.config.region = 'ap-southeast-1' // 1. Enter your region

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'ap-southeast-1:d3a76794-ef80-4000-a846-afb95dc782f3' // 2. Enter your identity pool
  })

  AWS.config.credentials.get(function(err) {
    if (err) alert(err)
  })

  var bucketName = 'smartapprcp' // Enter your bucket name
  var bucket = new AWS.S3({
    params: {
      Bucket: bucketName
    }
  })
  import api from '../../../api'
  import $ from 'jquery'

  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')
  // vue validations
  import {validationMixin} from 'vuelidate'
  import Multiselect from 'vue-multiselect'
  import {
    required
  } from 'vuelidate/lib/validators'
  import config from '../../../config'
  import Vue from 'vue'
  var moment = require('moment')
  Vue.component('multiselect', Multiselect)
  var SyncLoader = require('vue-spinner/src/SyncLoader')
  import VueQr from 'vue-qr'

  import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns'
  MultiSelect.Inject(CheckBoxSelection)

  export default {
    name: 'VideosView',
    components: {
      'SyncLoader': SyncLoader,
      Multiselect,
      VueQr
    },
    mixins: [validationMixin],
    data() {
      return {
        StateList: [],
        SelectedStateData: [],
        fields: { groupBy: 'country', text: 'state', value: 'id' },
        filterUserCount: 0,
        haveQR: false,
        qrRef: '',
        qrRefImage: '',
        src: '',
        src2: '/static/img/crp-images/QR-LOGO.png',
        qrModal: false,
        isDisabledOption: true,
        notifiModal: false,
        filterType: [],
        itemList: [],
        categoriesSelection: [],
        productsSelection: [],
        dataTable: null,
        IndustriesList: [],
        IndustrySelected: [],
        ProductSelected: [],
        qrcode: {
          video_id: '',
          qr_code: '',
          qr_url: ''
        },
        newForm: {
          id: null,
          name: null,
          description: null,
          category_id: null,
          products: [],
          url: null,
          states: [],
          status: null,
          thumbnail_small: null,
          thumbnail_medium: null,
          thumbnail_large: null,
          device_type: null,
          industries: []
        },
        form: {
          id: null,
          name: null,
          description: null,
          category_id: null,
          products: [],
          url: null,
          status: null,
          states: [],
          thumbnail_small: null,
          thumbnail_medium: null,
          thumbnail_large: null,
          device_type: null,
          industries: []
        },
        selectFilter_value: [],
        filter: {
          reference_id: '',
          type: 'video',
          filter_type: '',
          filter_value: ''
        },
        userCount: {
          type: 'video',
          filter_type: '',
          filter_value: ''
        },
        newFormBackendValidation: {
          name: {
            isError: false,
            errorMsg: ''
          },
          category_id: {
            isError: false,
            errorMsg: ''
          },
          products: {
            isError: false,
            errorMsg: ''
          },
          device_type: {
            isError: false,
            errorMsg: ''
          },
          description: {
            isError: false,
            errorMsg: ''
          },
          url: {
            isError: false,
            errorMsg: ''
          },
          industries: {
            isError: false,
            errorMsg: ''
          },
          states: {
            isError: false,
            errorMsg: ''
          }
        },
        editFormBackendValidation: {
          name: {
            isError: false,
            errorMsg: ''
          },
          category_id: {
            isError: false,
            errorMsg: ''
          },
          products: {
            isError: false,
            errorMsg: ''
          },
          device_type: {
            isError: false,
            errorMsg: ''
          },
          description: {
            isError: false,
            errorMsg: ''
          },
          url: {
            isError: false,
            errorMsg: ''
          },
          industries: {
            isError: false,
            errorMsg: ''
          },
          states: {
            isError: false,
            errorMsg: ''
          }
        },
        active: false,
        editModal: false,
        newModal: false,
        editModalColor: '#FECD2F',
        editModalSize: '10px',
        editModalLoading: false,
        editModalHeight: '35px',
        editModalWidth: '5px',
        editModalMargin: '2px',
        editModalRadius: '2px',
        newModalColor: '#FECD2F',
        newModalSize: '10px',
        newModalLoading: false,
        newModalHeight: '35px',
        newModalWidth: '5px',
        newModalMargin: '2px',
        newModalRadius: '2px'
      }
    },
    mounted() {
      // clear new modal
      var ref = this
      $('h3').on('click', 'button.clear-new-modal', function () {
        ref.clearForm()
      })
      this.$nextTick(() => {
        this.initDatatable()
        this.initJqueryMethods()
      })
    },
    validations: {
      form: {
        name: {
          required
        },
        description: {
          required
        },
        category_id: {
          required
        },
        products: {
          required
        },
        url: {
          required
        },
        device_type: {
          required
        },
        industries: {
          required
        },
        states: {
          required
        }
      },
      newForm: {
        name: {
          required
        },
        description: {
          required
        },
        category_id: {
          required
        },
        products: {
          required
        },
        url: {
          required
        },
        device_type: {
          required
        },
        industries: {
          required
        },
        states: {
          required
        }
      }
    },
    created() {
      this.getStateList()
      this.getProductList()
      this.setCategoryDropDownData()
      this.setProductDropDownData()
      this.getIndustriesList()
    },
    methods: {
      GetUserCount(selectData) {
        if (this.filter.filter_type === null || this.filter.filter_type === '' || this.selectFilter_value.length <= 0) {
          console.log('ok')
        } else {
          var ref = this
          var b = false
          for (let x = 0; x < ref.selectFilter_value.length; x++) {
            if (ref.selectFilter_value[x] === 'all') {
              b = true
            }
          }
          if (b) {
            this.userCount.filter_value = 'all'
          } else {
            this.userCount.filter_value = this.selectFilter_value
          }
          api.request('post', '/count_user/send-notification', this.userCount)
            .then(response => {
              if (response.status === 200) {
                if (response.data.result.status !== 'error') {
                  ref.filterUserCount = response.data.result
                } else {
                  ref.filterUserCount = 0
                }
              } else {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: 'Something wrong'})
              }
            }).catch(error => {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: error})
            })
        }
      },
      printQR() {
        this.$htmlToPaper('printSection')
      },
      qrRefNumber() {
        var randomMathName = Math.floor(Math.random() * 100000000000)
        this.qrRef = 'rb_' + randomMathName
        console.log('ok')
      },
      generateQRimageURL(dataUrl) {
        this.qrRefImage = dataUrl
      },
      uploadQrCode() {
        var ref = this
        function urltoFile(url, filename, mimeType) {
          return fetch(url)
            .then(function(res) {
              return res.arrayBuffer()
            })
            .then(function(buf) {
              return new File([buf], filename, { type: mimeType })
            })
        }
        var imgName = this.qrRef + '.png'
        var path = 'rcp_qr/' + imgName
        this.qrcode.qr_url = path
        this.qrcode.qr_code = this.qrRef
        urltoFile(this.qrRefImage, imgName).then(function(file) {
          var objKey = 'rcp_qr/' + file.name
          var params = {
            Key: objKey,
            ContentType: 'image/png',
            Body: file,
            ACL: 'public-read'
          }
          bucket.putObject(params, function(err, data) {
            if (err) {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: err})
            } else {
              ref.qrUpdataDB()
              console.log('ok')
            }
          })
        })
      },
      qrUpdataDB() {
        var ref = this
        api.request('post', '/admin/videos/store_qrcode', this.qrcode)
          .then(response => {
            if (response.status === 200) {
              this.haveQR = false
              // this.qrModal = false
              ref.dataTable.ajax.reload(null, false)
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },
      qrGenarater(id, code, url) {
        this.qrcode.video_id = id
        this.qrcode.qr_code = code
        this.qrcode.qr_url = url
        this.qrModal = true
        if (this.qrcode.qr_code === 'null' || this.qrcode.qr_code === '') {
          this.haveQR = true
          this.qrRefNumber()
        } else {
          this.haveQR = false
        }
      },
      triggerNotification() {
        if (this.filter.filter_type === null || this.filter.filter_type === '' || this.selectFilter_value.length <= 0) {
          // eslint-disable-next-line no-undef
          toast.fire({icon: 'error', title: 'Select filter type'})
        } else {
          var ref = this
          var b = false
          for (let x = 0; x < ref.selectFilter_value.length; x++) {
            if (ref.selectFilter_value[x] === 'all') {
              ref.selectFilter_value = []
              ref.selectFilter_value.push('all')
              b = true
            }
          }
          if (b) {
            this.filter.filter_value = 'all'
          } else {
            this.filter.filter_value = this.selectFilter_value
          }
          api.request('post', '/send-notification', this.filter)
            .then(response => {
              if (response.status === 200) {
                this.notifiModal = false
                this.filter.reference_id = ''
                this.filter.filter_type = ''
                this.filter.filter_value = ''
                this.selectFilter_value = []
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: 'Something wrong'})
              }
            }).catch(error => {
            // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: error})
            })
        }
      },
      loadFilterData(type) {
        this.isDisabledOption = false
        this.userCount.filter_type = type
        api.request('get', '/send-notification/videos')
          .then(response => {
            if (response.status === 200) {
              if (type === 'industry') {
                this.filterType = response.data.result.industries
              } else if (type === 'organization') {
                this.filterType = response.data.result.organizations
              } else if (type === 'state') {
                this.filterType = response.data.result.states
              } else if (type === 'user') {
                this.filterType = response.data.result.users
              }
              this.selectFilter_value = []
              this.filterUserCount = 0
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },
      notificationTrigger(id) {
        this.filter.reference_id = id
        this.notifiModal = true
      },
      getIndustriesList() {
        api
          .request('get', '/admin/industries/select')
          .then(response => {
            this.IndustriesList = response.data.result
          })
      },
      clearForm() {
        this.$v.$reset()
        this.newForm.name = ''
        this.newForm.description = ''
        this.newForm.category_id = ''
        this.newForm.products = []
        this.newForm.url = ''
        this.newForm.status = '1'
        this.newForm.thumbnail_small = ''
        this.newForm.thumbnail_medium = ''
        this.newForm.thumbnail_large = ''
        this.newForm.device_type = 'b'
        this.newForm.industries = ''
        this.IndustrySelected = ''
      },
      initJqueryMethods() {
        var ref = this
        // edit modal open
        $('#tableData tbody').on('click', 'td.details-control button.btn-modal-edit', function () {
          var id = $(this).attr('data-id')
          ref.showEditModal(id)
        })
        // delete record
        $('#tableData tbody').on('click', 'td.details-control button.btn-delete', function () {
          var id = $(this).attr('data-id')
          ref.deleteRecord(id)
        })
        // notifi record
        $('#tableData tbody').on('click', 'td.details-control button.btn-notifi', function () {
          var id = $(this).attr('data-id')
          ref.notificationTrigger(id)
        })
         // QR record
        $('#tableData tbody').on('click', 'td.details-control button.btn-qr', function () {
          var id = $(this).attr('data-id')
          var qrcode = $(this).attr('data-code')
          var qrurl = $(this).attr('data-url')
          ref.qrGenarater(id, qrcode, qrurl)
        })
        $('#tableData tbody').on('click', 'td.details-control button.btn-qr2', function () {
          var id = $(this).attr('data-id')
          var qrcode = $(this).attr('data-code')
          var qrurl = $(this).attr('data-url')
          ref.qrGenarater(id, qrcode, qrurl)
        })
      },
      initDatatable() {
        this.dataTable = $('#tableData')
          .on('xhr.dt', function (e, settings, json, xhr) {
            json.recordsTotal = json.result.original.recordsTotal
            json.draw = json.result.original.draw
            json.recordsFiltered = json.result.original.recordsFiltered
          })
          .DataTable({
            serverSide: true,
            processing: true,
            responsive: true,
            paging: true,
            lengthChange: true,
            searching: true,
            ordering: true,
            info: true,
            // autoWidth: false,
            search: {
              'caseInsensitive': false
            },

            order: [[0, 'desc']],
            ajax: {
              url: config.serverURI + '/admin/videos/datatable',
              type: 'get',
              contentType: 'application/json; charset=UTF-8',
              dataSrc: 'result.original.data',
              headers: { Authorization: 'Bearer ' + Vue.auth.getToken() }
            },
            columnDefs: [
              {
                'orderable': true,
                'targets': [0],
                'responsivePriority': 0,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + moment(full.updated_at).format('MM/DD/YYYY') + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [1],
                'responsivePriority': 1,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.name + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [2],
                'responsivePriority': 2,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.category.name + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [3],
                'responsivePriority': 3,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.description + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [4],
                'responsivePriority': 4,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  for (var product of full.products) {
                    return '<span>' + product.name + '</span>'
                  }
                  return '<span>N/A</span>'
                }
              },
              {
                'orderable': true,
                'targets': [5],
                'responsivePriority': 5,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  if (full.status === '1') {
                    return '<span class="badge bg-green">Active</span>'
                  } else if (full.status === 0) {
                    return '<span class="badge bg-primary">Deactive</span>'
                  }
                  return '<span class="badge badge-warning">N/A</span>'
                }
              },
              {
                'orderable': false,
                'targets': [6],
                'responsivePriority': 6,
                'searchable': false,
                'className': 'details-control',
                'render': function (data, type, full, meta) {
                  if (full.qr_code === null || full.qr_code === '') {
                    return '<button type="button" data-id= ' + full.id + ' class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-pencil" aria-hidden="true"></i>' +
                      '</button>&nbsp;<button data-id= ' + full.id + ' type="button" class="btn btn-danger btn-sm btn-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></button>' +
                      '&nbsp;<button data-id= ' + full.id + ' type="button" class="btn btn-notifi btn-sm btn-notifi"><i class="fa fa-bell" aria-hidden="true"></i></button>' +
                      '&nbsp;<button data-id= ' + full.id + ' data-code= ' + full.qr_code + ' data-url= ' + full.qr_url + ' class="btn btn-qr btn-sm btn-qr" type="button"><i class="fa fa-qrcode" aria-hidden="true"></i></button>'
                  } else {
                    return '<button type="button" data-id= ' + full.id + ' class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-pencil" aria-hidden="true"></i>' +
                      '</button>&nbsp;<button data-id= ' + full.id + ' type="button" class="btn btn-danger btn-sm btn-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></button>' +
                      '&nbsp;<button data-id= ' + full.id + ' type="button" class="btn btn-notifi btn-sm btn-notifi"><i class="fa fa-bell" aria-hidden="true"></i></button>' +
                      '&nbsp;<button data-id= ' + full.id + ' data-code= ' + full.qr_code + ' data-url= ' + full.qr_url + ' class="btn btn-qr2 btn-sm btn-qr2" type="button"><i class="fa fa-qrcode" aria-hidden="true"></i></button>'
                  }
                }
              }
            ]
          })
      },
      getProductList() {
        api.request('get', '/admin/videos')
          .then(response => {
            this.itemList = response.data.result
          })
      },
      getStateList() {
        api
          .request('get', '/admin/state/select-specific')
          .then(response => {
            this.StateList = response.data.result
          })
      },
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      getValidationClassNewForm(fieldName) {
        const field = this.$v.newForm[fieldName]
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      validateUser() {
        if (this.IndustrySelected.length > 0) {
          this.newForm.industries = []
          this.form.industries = []
          for (let x = 0; x < this.IndustrySelected.length; x++) {
            this.newForm.industries.push(this.IndustrySelected[x].id)
            this.form.industries.push(this.IndustrySelected[x].id)
          }
        }
        this.$v.$touch()

        if (!this.$v.newForm.$invalid && this.newModal) {
          this.addNewRecord(true)
        }
        if (!this.$v.form.$invalid && this.editModal) {
          this.addNewRecord(false)
        }
      },
      // addNewData() {
      //   for (let x = 0; x < this.IndustrySelected.length; x++) {
      //     this.newForm.industries.push(this.IndustrySelected[x].id)
      //   }
      //   console.log(this.newForm)
      // },
      addNewRecord(isNew) {
        var ref = this
        // get Vimeo thum images
        // http://vimeo.com/api/v2/video/6271487.xml
        var formData = null
        if (isNew) {
          formData = this.$v.newForm.$model
        } else {
          formData = this.$v.form.$model
        }

        var url = formData.url
        url = url.split('/')
        var vimeoData = ''
        if (url[3] === 'video') {
          url[3] = url[4]
        }

        api.httpRequest('get', 'https://vimeo.com/api/v2/video/' + url[3] + '.json')
          .then(response => {
            vimeoData = response.data
            formData.thumbnail_small = vimeoData[0].thumbnail_small
            formData.thumbnail_medium = vimeoData[0].thumbnail_medium
            formData.thumbnail_large = vimeoData[0].thumbnail_large
            if (isNew) {
              this.$v.newForm.$model.url = 'https://player.vimeo.com/video/' + url[3]
              this.createRecord(formData)
            } else {
              this.$v.form.$model.url = 'https://player.vimeo.com/video/' + url[3]
              this.updateRecord(formData)
            }
          }).catch(error => {
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            if (isNew) {
              ref.newFormBackendValidation.url.isError = true
              ref.newFormBackendValidation.url.errorMsg = error.Error
              $('.url').addClass('md-invalid')
            } else {
              ref.editFormBackendValidation.url.isError = true
              ref.editFormBackendValidation.url.errorMsg = error.Error
              $('.url').addClass('md-invalid')
            }
            this.response = 'Server appears to be offline'
            // this.toggleLoading()
          })
      },
      setCategoryDropDownData() {
        api.request('get', '/admin/categories/select')
          .then(response => {
            this.categoriesSelection = response.data.result
          })
      },
      setProductDropDownData() {
        api.request('get', '/admin/products/select')
          .then(response => {
            this.productsSelection = response.data.result
          })
      },
      showEditModal(id) {
        this.IndustrySelected = []
        api.request('get', '/admin/videos/show/' + id)
          .then(response => {
            if (response.status === 200) {
              this.form = response.data.result
              for (let x = 0; x < this.form.industries.length; x++) {
                for (let y = 0; y < this.IndustriesList.length; y++) {
                  if (this.form.industries[x] === this.IndustriesList[y].id) {
                    this.IndustrySelected.push(this.IndustriesList[y])
                  }
                }
              }
              this.editModal = true
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },
      updateRecord(data) {
        this.editModalLoading = true
        var ref = this
        api.request('post', '/admin/videos/update/' + data.id, data)
          .then(response => {
            if (response.status === 200) {
              this.editModalLoading = false
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.editFormBackendValidation.hasOwnProperty(key.toString())) {
                    ref.editFormBackendValidation[key.toString()].isError = true
                    ref.editFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                    $('.' + key.toString()).addClass('md-invalid')
                  }
                })
              } else if (response.data.result.status === 'success') {
                ref.editModal = false
                ref.dataTable.ajax.reload(null, false)
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else if (response.data.result.status === 'error') {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: response.data.result.message})
              }
            } else {
              ref.newModalLoading = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
            // if (response.status === 200 || response.status.status === 'success') {
            //   this.form = response.data.result
            //   this.editModalLoading = false
            //   ref.editModal = false
            //   this.dataTable.ajax.reload(null, false)
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'success', title: 'Record updated successfully'})
            // } else {
            //   this.editModalLoading = false
            //   // eslint-disable-next-line no-undef
            //   toast.fire({icon: 'error', title: 'Something wrong'})
            // }
          }).catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            this.editModalLoading = false
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      },
      createRecord(data) {
        this.newModalLoading = true
        data.status = 1
        var ref = this
        api.request('post', '/admin/videos/create', data)
          .then(response => {
            if (response.status === 200) {
              this.newModalLoading = false
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.newFormBackendValidation.hasOwnProperty(key.toString())) {
                    ref.newFormBackendValidation[key.toString()].isError = true
                    ref.newFormBackendValidation[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                    $('.' + key.toString()).addClass('md-invalid')
                  }
                })
              } else if (response.data.result.status === 'success') {
                ref.newModal = false
                ref.dataTable.ajax.reload(null, false)
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else if (response.data.result.status === 'error') {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: response.data.result.message})
              }
            } else {
              ref.newModalLoading = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            this.newModalLoading = false
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      },
      deleteRecord(id) {
        // eslint-disable-next-line no-undef
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            api.request('get', '/admin/videos/delete/' + id)
              .then(response => {
                if (response.status === 200 || response.status.status === 'success') {
                  // eslint-disable-next-line no-undef
                  toast.fire({icon: 'success', title: 'Record successfully deleted'})
                  this.dataTable.ajax.reload(null, false)
                }
              }).catch(error => {
              // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: error})
              })
          }
        })
      }
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

  @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_desc:after {
    font-family: 'FontAwesome';
  }

  table.dataTable thead .sorting:after {
    content: '\f0dc';
  }

  table.dataTable thead .sorting_asc:after {
    content: '\f0dd';
  }

  table.dataTable thead .sorting_desc:after {
    content: '\f0de';
  }


</style>



// WEBPACK FOOTER //
// VideosView.vue?e0259f0c